import React from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux'

import { setFormData } from '../redux/actions'

const StepWrapper = styled.div`
  max-width: 35rem;
  width: 100%;
  padding-top: 1rem;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  color: #FFFFFF;
`;

const InfoBar = styled.div`
  background-color: #F8F8F8;
  padding: 1rem;
  display: flex;
  justify-content: space-between;

  > div {
    > p {
      margin: 0;
    }
  }
`;

const SuccessWrapper = styled.div`
  padding: 1rem;
  background-color: #000000;
  color: #FFFFFF;

  p {
    color: #FFFFFF;
    font-size: 15px;
  }
`;

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const Step5 = ( { formData } ) => {

  return(
    <StepWrapper>
      <SuccessWrapper>
        <Header>Transfer Initiated</Header>
        <p>
          Good News! Your warranty transfer has been initiated.
          Review of your transfer request and documentation is under way.
          An Owens Corning representative will reach out to you should we need additional documentation.
        </p>
        <p>
        You will receive notification via mail/email once your request has been processed.
        </p>
        <p>
          *Please note, based on the terms of the warranty this transfer may be subject to a transfer fee*
        </p>
      </SuccessWrapper>
      <InfoBar>
        <div>
          <strong>Contact Name</strong>
          <p>{formData.firstName} {formData.lastName}</p>
        </div>
        <div>
          <strong>Property Address</strong>
          <p>{formData.propertyAddress.street} {formData.propertyAddress.streetLine2 && formData.propertyAddress.streetLine2}</p>
          <p>{formData.propertyAddress.city}, {formData.propertyAddress.state}, {formData.propertyAddress.zip}</p>
        </div>
      </InfoBar>
    </StepWrapper>
  )
};

const mapDispatchToProps = dispatch => (
  {
    setFormData: (hash) => dispatch(setFormData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step5);
